export enum PRIVILEGE_CODES {
  OWNER_MANAGEMENT = "OWNER", // Quản lý chủ sở hữu
  CUSTOMER_ACCOUNT_BASIC = "CUSTOMER_ACCOUNT_BASIC", // Quản lý tài khoản khách hàng (cơ bản)
  EMPLOYEE_MANAGEMENT_BASIC = "EMPLOYEE_MANAGEMENT_BASIC", // Quản lý nhân viên (cơ bản)
  EMPLOYEE_DEPARTMENT_MANAGEMENT = "EMPLOYEE_DEPARTMENT_MANAGEMENT", // Quản lý bộ phận nhân viên
  EMPLOYEE_PRIVILEGE_ASSIGNMENT = "EMPLOYEE_PRIVILEGE_ASSIGNMENT", // Quản lý phân quyền nhân viên
  SHIFT_SESSION_REPORT_MANAGEMENT = "SHIFT_SESSION_REPORT_MANAGEMENT", // Quản lý báo cáo ca làm việc
  SHIFT_SESSION_BASIC = "SHIFT_SESSION_BASIC", // Quản lý ca làm việc (cơ bản)
  ATTENDANCES_BASIC = "ATTENDANCES_BASIC", // Quản lý chấm công (cơ bản)
  SHIFT_BASIC = "SHIFT_BASIC", // Quản lý lịch làm việc (cơ bản)
  BRANCH_MANAGEMENT = "BRANCH_MANAGEMENT", // Quản lý chi nhánh
  COMPUTER_BASIC = "COMPUTER_BASIC", // Quản lý máy tính (cơ bản)
  AREA_BASIC = "AREA_BASIC", // Quản lý khu vực (cơ bản)
  PRODUCT_MATERIAL_MANAGEMENT = "PRODUCT_MATERIAL_MANAGEMENT", // Quản lý vật liệu sản phẩm
  //   PRODUCT_ASSIGNMENT_BASIC = "PRODUCT_ASSIGNMENT_BASIC", // Quản lý phân quyền nhân viên
  WAREHOUSE_BASIC = "WAREHOUSE_BASIC", // Quản lý kho (cơ bản)
  INVENTORY_BASIC = "INVENTORY_BASIC", // Kiểm kê kho (cơ bản)
  RECEIPT_PAYMENT_BASIC = "RECEIPT_PAYMENT_BASIC", // Quản lý thu chi (cơ bản)
  RECEIPT_PAYMENT_CATEGORY_MANAGEMENT = "RECEIPT_PAYMENT_CATEGORY_MANAGEMENT", // Quản lý danh mục thu chi
  ORDER_PENDING = "ORDER_PENDING", // Quản lý đơn hàng (chờ xác nhận)
  ORDER_CONFIRM = "ORDER_CONFIRM", // Quản lý đơn hàng (đã xác nhận)
  ORDER_COMPLETED = "ORDER_COMPLETED", // Quản lý đơn hàng (đã hoàn thành)
  ORDER_DONE = "ORDER_DONE", // Quản lý đơn hàng (đã hoàn thành)
  ORDER_CANCEL = "ORDER_CANCEL", // Quản lý đơn hàng (đã hủy)
  ORDER_MANAGEMENT = "ORDER_MANAGEMENT", // Quản lý đơn hàng
  BOOKING_MANAGEMENT = "BOOKING_MANAGEMENT", // Quản lý đặt chỗ
  RECHARGE_PACKAGE_MANAGEMENT = "RECHARGE_PACKAGE_MANAGEMENT", // Quản lý gói nạp tiền
  TOPUP_BASIC = "TOPUP_BASIC", // Quản lý nạp tiền (cơ bản)
  GAME_MANAGEMENT = "GAME_MANAGEMENT", // Quản lý game
  PROMOTION_COMBO_MANAGEMENT = "PROMOTION_COMBO_MANAGEMENT", // Quản lý khuyến mãi theo combo
  PROMOTION_CONFIRM = "PROMOTION_CONFIRM", // Quản lý khuyến mãi (đã xác nhận)
  PROMOTION_TICKET_MANAGEMENT = "PROMOTION_TICKET_MANAGEMENT", // Quản lý khuyến mãi vé giờ chơi
  PROMOTION_RECHARGE_PACKAGE_MANAGEMENT = "PROMOTION_RECHARGE_PACKAGE_MANAGEMENT", // Quản lý khuyến mãi gói nạp
  PROMOTION_MEMBERSHIP_LEVEL_MANAGEMENT = "PROMOTION_MEMBERSHIP_LEVEL_MANAGEMENT", // Quản lý khuyến mãi hạng thành viên
  PROMOTION_CUSTOMER_DISCOUNT_MANAGEMENT = "PROMOTION_CUSTOMER_DISCOUNT_MANAGEMENT", // Quản lý khuyến mãi theo tài khoản
  PROMOTION_AREA_DISCOUNT_MANAGEMENT = "PROMOTION_AREA_DISCOUNT_MANAGEMENT", // Quản lý khuyến mãi giờ chơi theo khu vực
  NEWS_MANAGEMENT = "NEWS_MANAGEMENT", // Quản lý tin tức
  SYSTEM_SETTINGS = "SYSTEM_SETTINGS", // Cài đặt hệ thống
  API_KEY_MANAGEMENT = "API_KEY_MANAGEMENT", // Quản lý API Key
  REPORT_MANAGEMENT = "REPORT_MANAGEMENT", // Quản lý báo cáo
  PAYMENT_CONFIRM = "PAYMENT_CONFIRM", // Quyền xác nhận thu tiền
  CUSTOMER_RESET_PASSWORD = "CUSTOMER_RESET_PASSWORD", // Quyền đặt lại mật khẩu khách hàng
  PAYMENT_TRANSFER_CONFIRM_MANAGEMENT = "PAYMENT_TRANSFER_CONFIRM_MANAGEMENT", // Quản lý xác nhận chuyển khoản
  ACTIVITY_LOG_VIEW = "ACTIVITY_LOG_VIEW", // Quyền xem logs hoạt động
  CUSTOMER_IMPORT = "CUSTOMER_IMPORT", // Quyền import khách hàng bằng Excel
  VOUCHER_MANAGEMENT = "VOUCHER_MANAGEMENT", // Quản lý voucher khuyến mãi
  PROMOTION_MASTER_MANAGEMENT = "PROMOTION_MASTER_MANAGEMENT", // Quản lý chiến dịch khuyến mãi
  PROMOTION_CREDIT_MANAGEMENT = "PROMOTION_CREDIT_MANAGEMENT", // Quản lý tặng tiền khuyến mãi
  ZALO_APP_MANAGEMENT = "ZALO_APP_MANAGEMENT", // Quản lý Zalo Mini App
  CUSTOMER_ID_VERIFICATION = "CUSTOMER_ID_VERIFICATION", // Xác minh CCCD khách hàng (C-15, CR-8)
  BANK_TRANSFER_MANAGEMENT = "BANK_TRANSFER_MANAGEMENT", // Quản lý chuyển khoản ngân hàng (Pay2S, C-27)
  ZALO_OA_INBOX = "ZALO_OA_INBOX", // Quản lý hộp thư Zalo OA
}
